module.exports = __webpack_public_path__ + "img/1521107220.edac3a8e.jpg";